import client from "./axios";
import { DataspaceConnector, DataspaceConnectorResource, Policy, PolicyField, PublishResourceDTO } from "../models/DataSpace";

const dataRetrieverUrl = `${window.__env.GATEWAY_URL}/v1/data-retriever`;
const connectorsUrl = `${dataRetrieverUrl}/connectors`;
const resourcesUrl = `${dataRetrieverUrl}/resources`;

export const DataRetriever = {
  getDataspaceConnectors: (params?: URLSearchParams) => client.get<DataspaceConnector[]>(`${connectorsUrl}`, { params }),
  getDataspaceConnectorsByUrl: (alidaUrl: string) => client.get<DataspaceConnector[]>(`${connectorsUrl}`, {
    headers: { 'AlidaUrl': alidaUrl }
  }),
  getDataspaceConnector: (id: string) => client.get<DataspaceConnector>(`${connectorsUrl}/${id}`),
  createDataspaceConnector: (dsConn: DataspaceConnector) => client.post<DataspaceConnector>(`${connectorsUrl}`, dsConn),
  editDataspaceConnector: (dsConn: DataspaceConnector) => client.put<DataspaceConnector>(`${connectorsUrl}/${dsConn.id}`, dsConn),
  deleteDataspaceConnnector: (id: string) => client.delete(`${connectorsUrl}/${id}`),
  getCatalogues: (connectorId: string, user: string, password: string) => client.get<string[]>(`${connectorsUrl}/${connectorId}/catalogues`, {
    headers: {
      'ConnectorBasicAuth': `${user}:${password}`
    }
  }),
  publishResource: (id: string, body: PublishResourceDTO, user: string, password: string, resourceCatalogId: string) => client.post(`${connectorsUrl}/${id}/publish`, body, {
    headers: {
      'ConnectorBasicAuth': `${user}:${password}`,
      'ResourceCatalogId': resourceCatalogId
    }
  }),
  unpublishResource: (connectorId: string, id: string, user: string, password: string) => client.delete(`${connectorsUrl}/${connectorId}/resources/${id}`, {
    headers: {
      'ConnectorBasicAuth': `${user}:${password}`,
    }
  }),
  // getPublishedResources: (id: string) => client.get<DataspaceConnectorResource[]>(`${connectorsUrl}/${id}/resources`),
  getPublishedResource: (id: string, resourceId: string) => client.get<DataspaceConnectorResource>(`${connectorsUrl}/${id}/resources/${resourceId}`),
  getPolicies: () => client.get<Policy[]>(`${resourcesUrl}/policies`),
  getAvailablePolicies: () => client.get<string[]>(`${resourcesUrl}/policies/available`),
  getPolicyFields: (id: string) => client.get<PolicyField[]>(`${resourcesUrl}/policies/${id}`),
  getPoliciesByType: (type: string) => client.get<Policy[]>(`${resourcesUrl}/policies/types/${type}`),
  // buildPolicy: (policyId: string, body: any) => client.post<string>(`${resourcesUrl}/policies/${policyId}/build`, body),
}